<ng-container *ngIf="date$ | async as date">
  <ng-container *ngIf="isDateFormat$ | async; else calendarFormat">
    {{ date | moment | amDateFormat : (format$ | async) }}
  </ng-container>
  <ng-template #calendarFormat>
    {{ date | moment | amCalendar : (format$ | async) }}
  </ng-template>
</ng-container>
